<template>
    <v-col
            class="primary darken-3 py-4 text-center white--text"
            cols="3"
    >
        <v-list class="py-0" :color="color">
<!--            <v-subheader inset class="primary font-weight-bold">{{title}}</v-subheader>-->
<!--            <v-list-item-group v-model="list">-->
            <v-list-item-group>
                <v-list-item v-for="(link, i) in list"
                             :key="i"
                             color="secondary"
                             text
                             rounded
                             class="my-0"
                             :to="{name: link.route}">
                    <v-list-item-content>
                        <v-list-item-title v-text="link.title"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-col>
</template>

<script>
    export default {
        name: "WFooterList",
        props: {
            title: {
                type: String,
                default: 'N/A',
                required: false
            },
            list: {
                type: Array,
                // default: '[]',
                required: false
            },
            color: {
                type: String,
                default: 'primary darken-2',
                required: false
            },
            textcolor: {
                type: String,
                default: 'primary',
                required: false
            }
        }
    }
</script>

<style scoped>

</style>